import React from 'react';
import { ComplexValue } from 'app/types-shared';
import styles from './section-list.scss';

interface SectionListProps {
  values: ComplexValue<number>[];
}

export const SectionList: React.FC<SectionListProps> = ({ values }) =>
  <ul className={`${styles.sectionList} mb-3`}>
    {values.map(value => <li key={value?.value}>{value?.description}</li>)}
  </ul>;
